export default __webpack_public_path__ + "static/media/profilep.7647320a.png";